import React from 'react';
import { CheckCircle, AlertCircle, Server } from 'lucide-react';

export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'active':
      return <CheckCircle className="w-5 h-5 text-green-500" />;
    case 'inactive':
      return <AlertCircle className="w-5 h-5 text-yellow-500" />;
    case 'error':
      return <AlertCircle className="w-5 h-5 text-red-500" />;
    default:
      return <Server className="w-5 h-5 text-gray-400" />;
  }
};

export const getProviderInfo = (type: string) => {
  const baseClasses = 'w-12 h-12 rounded-xl flex items-center justify-center';
  
  switch (type.toLowerCase()) {
    case 'cloudflare':
      return {
        logo: (
          <div className={`${baseClasses} bg-gradient-to-r from-orange-500 to-yellow-500 text-white`}>
            ☁️
          </div>
        ),
        name: 'Cloudflare',
        description: 'Global CDN & DNS',
        color: 'text-orange-600 dark:text-orange-400',
        bgColor: 'bg-orange-100 dark:bg-orange-900/30',
      };
    case 'route53':
    case 'aws':
      return {
        logo: (
          <div className={`${baseClasses} bg-gradient-to-r from-yellow-500 to-orange-500 text-white`}>
            🏢
          </div>
        ),
        name: 'AWS Route53',
        description: 'Amazon Web Services',
        color: 'text-orange-600 dark:text-orange-400',
        bgColor: 'bg-orange-100 dark:bg-orange-900/30',
      };
    case 'azure':
      return {
        logo: (
          <div className={`${baseClasses} bg-gradient-to-r from-blue-500 to-cyan-500 text-white`}>
            📊
          </div>
        ),
        name: 'Azure DNS',
        description: 'Microsoft Azure',
        color: 'text-blue-600 dark:text-blue-400',
        bgColor: 'bg-blue-100 dark:bg-blue-900/30',
      };
    case 'gcp':
    case 'google':
      return {
        logo: (
          <div className={`${baseClasses} bg-gradient-to-r from-blue-500 to-green-500 text-white`}>
            🌐
          </div>
        ),
        name: 'Google Cloud DNS',
        description: 'Google Cloud Platform',
        color: 'text-blue-600 dark:text-blue-400',
        bgColor: 'bg-blue-100 dark:bg-blue-900/30',
      };
    case 'digitalocean':
      return {
        logo: (
          <div className={`${baseClasses} bg-gradient-to-r from-blue-500 to-cyan-500 text-white`}>
            🌊
          </div>
        ),
        name: 'DigitalOcean DNS',
        description: 'Cloud Infrastructure',
        color: 'text-blue-600 dark:text-blue-400',
        bgColor: 'bg-blue-100 dark:bg-blue-900/30',
      };
    default:
      return {
        logo: (
          <div className={`${baseClasses} bg-gray-500 text-white`}>
            <Server className="w-6 h-6" />
          </div>
        ),
        name: 'DNS Provider',
        description: 'DNS Management',
        color: 'text-gray-600 dark:text-gray-400',
        bgColor: 'bg-gray-100 dark:bg-gray-900/30',
      };
  }
};